export default __webpack_public_path__ + "static/media/arc-landingpage.338f5b00.png";